import React, {useState, useEffect, useRef} from 'react'
import Product from './comp-prod'
import './style.css'
import {useHistory} from 'react-router-dom'

export default function Bayar() {
    const [timerHouse, setTimerHouse] = useState('0')
    const [timerMinuts, setTimerMinuts] = useState('0')
    const [timerSecons, setTimerSecons] = useState('0')

    const history = useHistory()
    const handleClick = () => {
        history.push('/upload_bayar')
    }


    let interval = useRef()

    const startTimer = () => {
        const countDownDate = new Date('september 7, 2021 00:00:00').getTime()

        interval = setInterval(() => {
            const now = new Date().getTime()
            const distance = countDownDate - now;

            const hours = Math.floor((distance % (1000 * 60 * 60 * 24) / (1000 * 60 * 60)))
            const minuts = Math.floor((distance % (1000 * 60 * 60 )) / (1000 * 60 ))
            const secons = Math.floor((distance % (1000 * 60 )) / 1000)

            if(distance < 0) {
                clearInterval(interval.current)
            } else {
                setTimerHouse(hours)
                setTimerMinuts(minuts)
                setTimerSecons(secons)
            }
        }, 1000)
    }

    useEffect(() => {
        startTimer();
    })

    return (
        <div className="componenet-bayar">
            <div>
                <Product />
                <div className="time-later-product">
                    <h3>Silakan segera menyelesaikan pembayaran sebelum</h3>
                    <div className="timer">
                        <h2>{timerHouse}<span>Jam</span> :</h2>
                        <h2>{timerMinuts}<span>Menit</span> :</h2>
                        <h2>{timerSecons}<span>Detik</span></h2>
                    </div>
                </div>
            </div>
            <div className="pembayaran">
                <h6>Belum Dibayar</h6>
                <p>Total yang harus dibayar</p>
                <h2>Rp. 160.000</h2>
                <div className="group-tombol">
                   <a href="https:wa.me/+6285349780521" target="_blank" rel="noopener noreferrer"> 
                       <button type="button" target="_blank">Hubungi Toko</button>
                   </a>
                    <button onClick={handleClick} type="button">Bayar</button>
                </div>
            </div>
        </div>
    )
}
